import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FirstStepComponent } from './host-party/first-step/first-step.component';
import { HostGuideComponent } from './host-guide/host-guide.component';
import { HostComponent } from './host/host.component';
import { JoinPartiesComponent } from './host/join-parties/join-parties.component';
import { ScreeningPartiesHomepageComponent } from './screening-parties-homepage/screening-parties-homepage.component';
import { AuthGuard } from 'src/app/core/authentication/auth.guard';
import { ScreeningPartyInvitationComponent } from './host/screening-party-invitation/screening-party-invitation.component';

const routes: Routes = [
  {
    path: '',
    component: ScreeningPartiesHomepageComponent,
  },
  {
    path: 'host',
    component: HostComponent,
  },
  {
    path: 'host-guide',
    component: HostGuideComponent,
  },
  {
    path: 'getting-started',
    component: FirstStepComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'export/invitation/:id',
    component: ScreeningPartyInvitationComponent
  },
  {
    path: 'join',
    component : JoinPartiesComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScreeningPartiesRoutingModule { }
